export default __webpack_public_path__ + "static/media/login-image-1.2b76891a.png";